<script setup lang="ts">
import ErrorLayout from "./layouts/ErrorLayout.vue";
import { useIdleLogout } from "./composables/useIdleLogout";

useIdleLogout();
</script>

<template>
  <div class="relative bg-width-animate">
    <ErrorLayout />
    <router-view />
  </div>
</template>

<style scoped>
html,
body {
  @apply bg-grey-100;
}

.bg-width-animate {
  -webkit-transition: width 1s ease-in-out;
  -moz-transition: width 1s ease-in-out;
  -o-transition: width 1s ease-in-out;
  transition: width 1s ease-in-out;
}
</style>
